/* Version: 3.5.149 */
'use client';
/**
 * Return true if IE 11 or older, else false
 */
var isIE = function isIE() {
  if (typeof window !== 'undefined') {
    var _navigator = navigator,
      userAgent = _navigator.userAgent;
    var ie11orOlder = userAgent.indexOf('MSIE ') >= 0 || userAgent.indexOf('Trident/') >= 0;
    if (ie11orOlder) {
      return true;
    }
  }
  return false;
};
var isChrome = function isChrome() {
  if (typeof window !== 'undefined') {
    var _navigator2 = navigator,
      userAgent = _navigator2.userAgent;
    if (userAgent.indexOf('Chrome') >= 0) {
      return true;
    }
  }
  return false;
};
var isIosOrAndroid = function isIosOrAndroid() {
  if (typeof window !== 'undefined') {
    var _navigator3 = navigator,
      userAgent = _navigator3.userAgent;
    if (userAgent.indexOf('iPhone') >= 0 || userAgent.indexOf('iPad') >= 0 || userAgent.indexOf('Android') >= 0) {
      return true;
    }
  }
  return false;
};
var isMobilePlatform = function isMobilePlatform() {
  if (typeof window !== 'undefined') {
    var _navigator4 = navigator,
      platform = _navigator4.platform;
    return !!platform && /iPad|iPhone|iPod|Android|BlackBerry/.test(platform);
  }
  return false;
};
var isSafari = function isSafari() {
  if (typeof window !== 'undefined') {
    var _navigator5 = navigator,
      userAgent = _navigator5.userAgent;
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      return true;
    }
  }
  return false;
};

export { isChrome, isIE, isIosOrAndroid, isMobilePlatform, isSafari };
